<section class="group-graph-wrapper" [class.has-data]="group?.data?.length > 0" *ngFor="let group of groups | async">
    <section>
        <section class="group-label">{{group?.title | stringTranslate}}</section>
        <gen-chart-widget
                [widgetConfig]="group?.mapping"
                [widgetData]="group?.data || []">
        </gen-chart-widget>
    </section>
</section>
